<script setup lang="ts">
import JoinContest from "@/components/JoinContest.vue";
import AgeVerification from "@/components/AgeVerification.vue";
import {onMounted, ref} from "vue";
import Cookie from "@/components/cookie/Cookie.vue";

const isAdult = ref(false);

const checkAge = (userAge: number) => {
    isAdult.value = !!(userAge && userAge >= 18);
}

onMounted(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const showHome = urlParams.get('showHome');

    if (showHome === 'true') {
        isAdult.value = true;
    }

})
</script>

<template>
    <main>
        <div>
            <Cookie></Cookie>
            <JoinContest v-if="isAdult"></JoinContest>
<!--            <JoinContestV2 v-if="isAdult"></JoinContestV2>-->
            <AgeVerification v-else @ageVerified="checkAge"></AgeVerification>
        </div>
    </main>
</template>
